import {configureStore, combineReducers} from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import authTokenSlice from "./slices/authTokenSlice";
import loginSlice from "./slices/loginSlice";
import dynamicUiSlice from "./slices/dynamicUiSlice";
import dynamicElementsSlice from "./slices/dynamicElementsSlice";
import {watcherSaga} from "./sagas/rootSaga";
import getDeliveryUserSlice from "./slices/deliverySlice";
import imageUploadSlice from "./slices/imageUploadSlice";
import notificationSlice from "./slices/notificationSlice";
import consultationSlice from "./slices/consultationSlice";
import promoEventSlice from "./slices/promoEventSlice";
import pharmacistSlice from "./slices/pharmacistSlice";
import focusItemsSlice from "./slices/focusItemsSlice";
import paymentVerificationSlice from "./slices/paymentVerificationSlice";
import remoteConfigSlice from "./slices/remoteConfigSlice";
import searchSlice from "./slices/searchSlice";
import dynamicElementsMultipleSlice from "./slices/dynamicMultipleElementsSlice";
import doctorSlice from './slices/doctorSlice';
import nurseSlice from './slices/nurseSlice';
import businessSlice from "./slices/businessSlice";
import campaignReportingSlice from "./slices/campaignReportingSlice";
import wishlistSlice from "./slices/wishlistSlice";
import nurseCampaignSlice from "./slices/nurseCampaignSlice";
import campaignShiftSlice from "./slices/shiftSlice";
import locationSlice from "./slices/locationSlice";
import prescriptionSlice from "./slices/prescriptionSlice";
import addressSlice from "./slices/addressSlice";
import bannerSlices from "./slices/bannerSlices";
import cartReportingSlice from "./slices/cartReportingSlice";
import notificationReportSlice from "./slices/notificationReportSlice";
import faqSlice from "./slices/faqSlice";
import predictionSlice from "./slices/predictionSlice";
import manageUserSlice from "./slices/manageUserSlice";
import permissionSlice from "./slices/permissionSlice";
import manageBlogSlice from "./slices/manageBlogSlice";
import rewardLoyaltySlice from "./slices/rewardLoyaltySlice";
import rewardCalculatorSlice from "./slices/rewardCalculatorSlice";
import rewardUsersSlice from "./slices/rewardUsersSlice";
import rewardPointsSlice from "./slices/rewardPointsSlice";
import dashboardSlice from "./slices/dashboardSlice";
import fulfillmentOperatorSlice from "./slices/fulfillmentOperatorSlice";


const sagaMiddleware = createSagaMiddleware();

const reducers = combineReducers({
  authToken: authTokenSlice,
  login: loginSlice,
  delivery: getDeliveryUserSlice,
  imageUpload: imageUploadSlice,
  notification: notificationSlice,
  consultation: consultationSlice,
  promoEvent: promoEventSlice,
  pharmacist: pharmacistSlice,
  focusItem: focusItemsSlice,
  paymentVerification: paymentVerificationSlice,
  remoteConfig: remoteConfigSlice,
  dynamicUi: dynamicUiSlice,
  search: searchSlice,
  dynamicElements: dynamicElementsSlice,
  dynamicMultipleElements: dynamicElementsMultipleSlice,
  doctor: doctorSlice,
  nurse: nurseSlice,
  business: businessSlice,
  campaignReporting: campaignReportingSlice,
  wishlist: wishlistSlice,
  cartList: cartReportingSlice,
  campaign: nurseCampaignSlice,
  shifts: campaignShiftSlice,
  location: locationSlice,
  prescription: prescriptionSlice,
  address: addressSlice,
  banner: bannerSlices,
  notificationReport: notificationReportSlice,
  faq: faqSlice,
  prediction: predictionSlice,
  manageUser: manageUserSlice,
  permission: permissionSlice,
  manageBlogs: manageBlogSlice,
  rewardLoyalty: rewardLoyaltySlice,
  rewardCalculator: rewardCalculatorSlice,
  rewardUsers: rewardUsersSlice,
  rewardPoints: rewardPointsSlice,
  dashboard: dashboardSlice,
  fulfillmentOperator: fulfillmentOperatorSlice,
});

const store = configureStore({
  reducer: reducers,
  // middleware: [...getDefaultMiddleware({thunk: false}), sagaMiddleware],
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware({
    thunk: false,
    serializableCheck: false
  }), sagaMiddleware]
});

sagaMiddleware.run(watcherSaga);

export default store;
